import { motion } from 'motion/react';
import { Link } from 'react-router';

export default function TermsAndPrivacy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Logo */}
          <div className="mb-8 flex justify-start">
            <Link to="/">
              <img
                src="/images/takassusi-consult-02.png"
                alt="Virtual Care Logo"
                className="h-34 w-34 object-contain"
              />
            </Link>
          </div>

          {/* Arabic Section */}
          <section dir="rtl" className="mb-16">
            <h1 className="mb-8 text-2xl font-bold text-gray-900">
              سياسة الاستخدام والخصوصية لمنصة استشر التخصصي
            </h1>

            <div className="space-y-8">
              {/* Section 1 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  1. المقدمة والغرض من السياسة
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  هذه السياسة تُنظم استخدام منصة استشر التخصصي، وتحدد حقوق
                  المستخدم والتزامات الشركة، وتوضح أساس تقديم الخدمة. يمثل
                  استخدامك للمنصة موافقة صريحة على الالتزام بجميع البنود، ويعد
                  استخدامك بمثابة اتفاق قانوني كامل وساري.
                </p>
                <p className="leading-relaxed text-gray-600">
                  المنصة تدار من قبل{' '}
                  <strong>شركة التخصصي العامة المحدودة</strong>، التابعة لشركة
                  مستشفى الملك فيصل التخصصي الدولية القابضة، والمملوكة بالكامل
                  لمستشفى الملك فيصل التخصصي ومركز الأبحاث، دون أن يترتب على هذا
                  الارتباط أي مسؤولية طبية أو مهنية على المستشفى أو الشركة
                  القابضة.
                </p>
              </div>

              {/* Section 2 - Definitions */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  2. التعاريف
                </h2>
                <ul className="list-disc space-y-3 pr-6 text-gray-600">
                  <li>
                    <strong>المنصة:</strong> منصة إستشر التخصصي الإلكترونية.
                  </li>
                  <li>
                    <strong>الشركة:</strong> شركة التخصصي العامة المحدودة،
                    التابعة لشركة مستشفى الملك فيصل التخصصي الدولية القابضة،
                    ويُشار إليها بـ "الشركة".
                  </li>
                  <li>
                    <strong>الشركة القابضة:</strong> شركة مستشفى الملك فيصل
                    التخصصي الدولية القابضة، المملوكة بالكامل للمستشفى، ويُشار
                    إليها بـ "الشركة القابضة".
                  </li>
                  <li>
                    <strong>المستشفى:</strong> مستشفى الملك فيصل التخصصي ومركز
                    الأبحاث، ويُشار إليها بـ "المستشفى".
                  </li>
                  <li>
                    <strong>المستخدم:</strong> الشخص الطبيعي يقوم بإنشاء حساب
                    على المنصة أو استخدام خدماتها، سواء كان ذلك لنفسه أو نيابةً
                    عن شخص آخر يملك صلاحية التمثيل النظامي وفق الأنظمة المعمول
                    بها.
                  </li>
                  <li>
                    <strong>الطبيب:</strong> ممارس صحي مرخص من الجهات المختصة في
                    المملكة العربية السعودية ومستقل عن الشركة أو الشركة القابضة
                    أو المستشفى، يقدم الاستشارة الطبية الرقمية عبر المنصة.
                  </li>
                  <li>
                    <strong>مزودي الخدمة:</strong> أي جهة خارجية، فرداً كان أم
                    شركة، تقوم بتوفير خدمات تشغيل المنصة أو دعمها وتقديم
                    الاستشارات الرقمية أو الخدمات المرتبطة بالمنصة، بما في ذلك
                    الخدمات التقنية والدعم الفني والدفع وخدمات البنية التحتية
                    وخدمات التحقق من الهوية والأمن السيبراني وخدمات الامتثال،
                    وغيرها من الخدمات اللازمة لتشغيل المنصة.
                  </li>
                  <li>
                    <strong>المستندات الطبية:</strong> جميع الوثائق أو المواد
                    الطبية المتعلقة بالحالة الصحية للمستخدم والتي تُقدَّم إلى
                    المنصة بهدف الحصول على استشارة طبية، وتشمل المستندات
                    المذكورة من المصادر المعتمدة مثل التقارير الطبية، نتائج
                    الفحوص، والصور التشخيصية، وتُعامل كبيانات صحية وفق سياسة
                    الخصوصية.
                  </li>
                  <li>
                    <strong>البيانات الصحية:</strong> كل بيان شخصي يتعلق بحالة
                    الفرد الصحية، سواء الجسدية أو العقلية أو النفسية أو المتعلقة
                    بالخدمات الصحية الخاصة به.
                  </li>
                  <li>
                    <strong>البيانات الشخصية:</strong> كل بيان – مهما كان مصدره
                    أو شكله – من شأنه ان يؤدي الى معرفة الفرد على وجه التحديد،
                    أو يجعل التعرف عليه ممكناً بصفة مباشرة أو غير مباشرة، ومن
                    ذلك: الاسم، ورقم الهوية الشخصية، والعناوين، وأرقام التواصل،
                    وأرقام الرُخص والسجلات والممتلكات الشخصية، وأرقام الحسابات
                    البنكية والبطاقات الائتمانية، وصور الفرد الثابتة أو
                    المتحركة، وغير ذلك من البيانات ذات الطابع الشخصي.
                  </li>
                  <li>
                    <strong>المعالجة:</strong> أي عملية تجرى على البيانات
                    الشخصية بوسيلة إلكترونية، ومن ذلك عمليات الجمع، والتسجيل،
                    والحفظ، والفهرسة، والترتيب، والتنسيق، والتخزين، والتعديل،
                    والتحديث، والدمج، والاسترجاع، والاستعمال، والإفصاح، والنقل،
                    والنشر، والمشاركة في البيانات أو الربط البيني، والحجب،
                    والمسح، والإتلاف.
                  </li>
                  <li>
                    <strong>الجمع:</strong> حصول المنصة على البيانات الشخصية
                    وفقاً لأحكام نظام البيانات الشخصية ولوائحها التنفيذية، سواء
                    من صاحبها مباشرة أو ممن يمثله، أو ممن له الولاية الشرعية
                    عليه أو من طرف آخر.
                  </li>
                  <li>
                    <strong>بيانات الجلسات:</strong> البيانات التقنية والتنظيمية
                    المرتبطة بالجلسة الطبية الرقمية، والتي يتم جمعها ومعالجتها
                    في سياق تقديم الاستشارة عبر المنصة، وتشمل: وقت البدء
                    والانتهاء، حالة الجلسة، بيانات الجهاز والاتصال (نوع الجهاز،
                    نظام التشغيل، المتصفح، عنوان IP، جودة الاتصال)، السجلات
                    الفنية (logs)، البيانات الوصفية (metadata)، وأي تسجيلات
                    للجلسة.
                  </li>
                  <li>
                    <strong>الخدمة:</strong> مجموعة الخدمات الإستشارية الطبية
                    الرقمية التي تتيحها المنصة للمستخدم.
                  </li>
                  <li>
                    <strong>الإستشارة الرقمية:</strong> الخدمة الطبية الرقمية
                    التي يقدمها الطبيب المرخّص عبر المنصة، وتشمل التواصل مع
                    المستخدم، مراجعة مستنداته الطبية، والإجابة على استفساراته
                    بهدف تقديم رأي طبي استشاري عام لدعم التقييم الصحي، دون أن
                    تُعد تشخيصًا سريريًا نهائيًا أو تشكل علاقة علاجية مباشرة مع
                    المستشفى.
                  </li>
                  <li>
                    <strong>الموعد:</strong> الحجز المؤكد والمدفوع مسبقاً لجلسة
                    استشارية مع طبيب محدد في تاريخ ووقت متفق عليهما عبر المنصة.
                  </li>
                  <li>
                    <strong>التشخيص الإستشاري:</strong> الرأي الطبي التحليلي
                    الصادر عن الطبيب المرخص بناءً على المستندات الطبية المقدّمة
                    عبر المنصة، ويهدف إلى دعم التقييم الطبي ضمن الخدمة الرقمية،
                    ولا يُعد تشخيصًا سريريًا نهائيًا ولا يُنشئ علاقة علاجية مع
                    المستشفى.
                  </li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  3. نطاق الخدمة وحدودها
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  1. توفر المنصة خدمات استشارية طبية رقمية تعتمد على:
                </p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>الاتصال المرئي مع الطبيب.</li>
                  <li>مراجعة المستندات الطبية المقدمة من المستخدم.</li>
                  <li>تقديم رأي طبي استشاري.</li>
                  <li>الإجابة على استفسارات المستخدم ذات الطابع الطبي.</li>
                </ul>
                <p className="mb-4 leading-relaxed text-gray-600">
                  2. الخدمة ذات طبيعة استشارية ولا تشكل علاجًا مباشرًا، ولا يمكن
                  اعتبارها بديلاً عن الفحص السريري أو التدخل الطبي التقليدي.
                </p>
                <p className="leading-relaxed text-gray-600">
                  3. على المستخدم إدراك أن أي توصية من الطبيب هي رأي طبي يعتمد
                  على المستندات الطبية المقدمة من المستخدم، وقد تتطلب مراجعة في
                  منشأة طبية.
                </p>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  4. المسؤولية الطبية
                </h2>
                <ul className="mb-4 list-disc space-y-3 pr-6 text-gray-600">
                  <li>
                    تُقدم الخدمة بواسطة أطباء مرخصون ومزاولون مهنة مستقلون وفق
                    أنظمة المملكة العربية السعودية، ولا يرتبط هؤلاء الاطباء
                    علاقة تنظيمية أو تبعية أو إشرافية بالشركة أو الشركة القابضة
                    أو المستشفى.
                  </li>
                  <li>
                    يتحمل الطبيب المسؤولية الكاملة عن:
                    <ul className="mt-2 list-disc space-y-1 pr-6">
                      <li>التشخيص الاستشاري.</li>
                      <li>الرأي الطبي.</li>
                      <li>التوصيات العلاجية.</li>
                      <li>أي تفسير أو شرح للمعلومات الطبية.</li>
                    </ul>
                  </li>
                  <li>
                    لا تتحمل الشركة، أو الشركة القابضة، أو المستشفى أي مسؤولية
                    عن:
                    <ul className="mt-2 list-disc space-y-1 pr-6">
                      <li>الأخطاء الطبية المهنية.</li>
                      <li>الآثار أو المضاعفات.</li>
                      <li>
                        سوء الفهم الناتج عن الاكتفاء بالاستشارة دون مراجعة طبية
                        حضورية.
                      </li>
                      <li>
                        اعتماد المستخدم على الاستشارة بما يخالف التعليمات
                        المبينة من الطبيب.
                      </li>
                    </ul>
                  </li>
                  <li>
                    لا تشكل المنصة ولا الشركة القابضة أو المستشفى علاقة توظيف أو
                    تبعية مهنية أو إدارية مع الطبيب تجاه المستخدمين، ولا تُعتبر
                    الجهات المذكورة طرفاً في العلاقة العلاجية الناتجة عن
                    الاستشارة الرقمية.
                  </li>
                  <li>
                    لا تنشأ الاستشارة المقدمة عبر المنصة أي علاقة علاجية مع
                    المستشفى إلا بعد قبول الحالة رسميًا وفق سياسات القبول
                    الداخلية، سواءً من حيث التغطية أو التقييم أو الطاقة
                    الاستيعابية، ولا يترتب عليها التزامات علاجية تتجاوز حدود
                    الاستشارة الرقمية.
                  </li>
                </ul>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  5. تعهدات المستخدم
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  يقر المستخدم بالموافقة على شروط سياسة الإستخدام والخصوصية، كما
                  يوافق على الإلتزام بما يلي:
                </p>
                <p className="mb-2 font-semibold text-gray-700">
                  1. إلتزامات المستخدم:
                </p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>
                    إدخال بيانات صحيحة وحديثة عند إنشاء الحساب او إستخدام خدمات
                    المنصة، وعدم الإدلاء بمعلومات خاطئة أو مظللة أو تشكل
                    إحتيالاً، أو استخدام مستندات مزورة.
                  </li>
                  <li>
                    رفع مستندات وتقارير طبية واضحة وغير معدلة بما يؤثر على دقة
                    الإستشارة الطبية.
                  </li>
                  <li>
                    استخدام الحساب بشكل شخصي وعدم مشاركة بيانات الدخول مع أي طرف
                    ثالث.
                  </li>
                  <li>
                    الالتزام بآداب وسلوكيات الاستخدام والإمتناع عن إساءة التواصل
                    مع الأطباء أو موظفي الدعم.
                  </li>
                  <li>
                    الامتناع عن أي محاولة للوصول الغير مشروع أو القيام بأي إجراء
                    قد يُعطّل المنصة أو يؤثر على أمنها أو سلامة أنظمتها.
                  </li>
                  <li>
                    عدم تقديم أو تحميل ملفات تحتوي على برمجيات ضارة أو فيروسات
                    أو بيانات تالفة.
                  </li>
                  <li>
                    تحمل كافة الغرامات المفروضة من الجهات الحكومية بناء على
                    مخالفته للأنظمة المعمول بها في المملكة العربية السعودية.
                  </li>
                </ul>
                <p className="leading-relaxed text-gray-600">
                  2. تحتفظ الشركة بحق اتخاذ أي إجراءات نظامية عند مخالفة
                  المستخدم لهذه الالتزامات، بما في ذلك تعليق الحساب أو إلغاؤه
                  دون إخلال بحقها في المطالبة بالتعويض عند الاقتضاء.
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  6. الاستخدام النظامي والممنوع للمنصة
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  1. يُعد استخدام المنصة خاضعًا للضوابط والشروط المنظمة للخدمة،
                  ويجب على جميع المستخدمين الالتزام بالاستخدام المشروع وبما لا
                  يخالف الأنظمة المعمول بها في المملكة أو سياسات الشركة. ويُحظر
                  أي استخدام قد يعرّض المنصة أو بيانات المستخدمين أو خدماتها
                  للخطر أو يخلّ بالأمان أو الخصوصية.
                </p>
                <p className="mb-2 font-semibold text-gray-700">
                  يشمل الاستخدام المشروع (دون الحصر):
                </p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>الاستفادة من الخدمة لأغراض طبية مشروعة.</li>
                  <li>تقديم استفسارات مرتبطة بالحالة الصحية للمستخدم.</li>
                  <li>
                    مشاركة تقارير وفحوصات تخص المستخدم نفسه أو من ينوب عنه
                    نظاميًا.
                  </li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">
                  يشمل الاستخدام الممنوع (دون الحصر):
                </p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>تقديم بيانات أو معلومات غير صحيحة.</li>
                  <li>رفع ملفات ضارة أو مشفرة بشكل يُصعّب فحصها الأمني.</li>
                  <li>
                    محاولة الوصول غير المصرّح به إلى حسابات أو بيانات مستخدمين
                    آخرين.
                  </li>
                  <li>
                    الترويج لخدمات أو منتجات خارجية أو القيام بأي نشاط إعلاني
                    عبر المنصة.
                  </li>
                  <li>
                    استخدام المنصة كقناة تواصل لغير الأغراض الطبية أو خارج نطاق
                    الاستخدام المخصص لها.
                  </li>
                  <li>
                    إرتكاب أي فعل مخالف لأنظمة المملكة العربية السعودية أو
                    لسياسات الشركة.
                  </li>
                </ul>
                <p className="leading-relaxed text-gray-600">
                  2. تحتفظ الشركة بحق اتخاذ أي اجراءات نظامية عند مخالفة
                  المستخدم للاستخدام المشروع للمنصة، بما في ذلك تعليق الحساب أو
                  إلغاؤه دون إخلال بحقها في المطالبة بالتعويض عند الاقتضاء أو
                  الإبلاغ للجهات المختصة.
                </p>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  7. المدفوعات، الإلغاء، وعدم الحضور
                </h2>
                <p className="mb-2 font-semibold text-gray-700">الدفع:</p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>يتم سداد الرسوم عبر مزودي خدمات دفع مرخصين.</li>
                  <li>تُعرض الرسوم قبل إتمام عملية الدفع.</li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">الإلغاء:</p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>
                    يحق للمستخدم الإلغاء قبل الموعد بما لا يقل عن ستة (6) ساعات.
                  </li>
                  <li>الشركة لا تلتزم بإعادة الجدولة بعد هذه المدة.</li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">عدم الحضور:</p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>
                    إذا لم يحضر المستخدم الموعد دون إلغاء ضمن المدة المحددة،
                    تعتبر الجلسة مستهلكة.
                  </li>
                  <li>
                    لا يحق للمستخدم المطالبة باسترداد الرسوم أو بأي تعويض عن عدم
                    حضور الموعد.
                  </li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">
                  عدم القدرة على تقديم الخدمة:
                </p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>
                    في حال تعذر تقديم الخدمة من الشركة، يتم إعادة المبلغ
                    للمستخدم أو إعادة جدولة الموعد.
                  </li>
                  <li>
                    سيجري التواصل مع المستخدم عبر خدمة العملاء خلال أقرب وقت
                    ممكن عند علم الشركة بالعجز عن تقديم الخدمة.
                  </li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">
                  استرداد الرسوم:
                </p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>
                    رسوم خدمات المنصة غير قابلة للإسترداد إلا حالة تعذر تقديم
                    الخدمة من الشركة، وذلك في أي من الحالات التالية:
                    <ul className="mt-2 list-disc space-y-1 pr-6">
                      <li>إلغاء الطبيب المختص الموعد بنفسه.</li>
                      <li>وجود أعطال تقنية أو توقف النظام عبر المنصة.</li>
                      <li>وجود أسباب داخلية للمنصة تمنع إتمام الجلسة.</li>
                    </ul>
                  </li>
                  <li>
                    يتم استرداد الرسوم عبر منصة تتبع مقدمي الخدمات المتعاقدين مع
                    الشركة لمعالجة المدفوعات، وفق سياسة الاسترداد المعتمدة.
                  </li>
                  <li>
                    زمن استرداد المبالغ يختلف بحسب طريقة الدفع كما يأتي:
                    <ul className="mt-2 list-disc space-y-1 pr-6">
                      <li>
                        بطاقة مدى: خلال 24 ساعة إلى ثلاثة أيام عمل من تاريخ
                        الموافقة على الإسترداد.
                      </li>
                      <li>
                        البطاقات الإئتمانية: خلال 72 ساعة حتى 14 يوم عمل من
                        تاريخ الموافقة على الإسترداد.
                      </li>
                    </ul>
                  </li>
                  <li>
                    لن تتحمل الشركة أي مسؤولية تجاه المستخدم عن أي خسارة ناتجة
                    عن أي فعل أو إغفال من قبل مزود خدمات الدفع الخارجي.
                  </li>
                </ul>
              </div>

              {/* Section 8 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  8. الأعطال التقنية والتواصل
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  1. لا تتحمل الشركة أي مسؤولية عن الأعطال التقنية التي قد تحدث
                  من طرف المستخدم، بما في ذلك على سبيل المثال لا الحصر:
                </p>
                <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                  <li>انقطاع الإنترنت لدى المستخدم.</li>
                  <li>ضعف الشبكة.</li>
                  <li>أعطال الجهاز المستخدم للوصول الى المنصة.</li>
                  <li>
                    استخدام نسخ قديمة أو غير محدثة من الأنظمة أو التطبيقات.
                  </li>
                </ul>
                <p className="leading-relaxed text-gray-600">
                  2. في حال كان سبب الخلل أو العطل من أنظمة الشركة، سيتم التواصل
                  مع المستخدم عبر خدمة العملاء لإعادة جدولة الموعد أو استرداد
                  الرسوم.
                </p>
              </div>

              {/* Section 9 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  9. القبول في المستشفى والعلاقة العلاجية
                </h2>
                <ul className="list-disc space-y-2 pr-6 text-gray-600">
                  <li>
                    الإحالة الصادرة من الطبيب عبر المنصة لا تُعد قبولاً رسمياً
                    للحالة لدى المستشفى.
                  </li>
                  <li>
                    يخضع قبول الحالات الى السياسات الداخلية للمستشفى فيما يخص
                    التقييم الطبي والقدرة الإستيعابية والاستحقاق.
                  </li>
                  <li>
                    لا تترتب على الاستشارة الرقمية أي حقوق أو التزامات علاجية
                    داخل المستشفى إلا بعد القبول الرسمي.
                  </li>
                  <li>
                    الاستشارة الرقمية لا تُنشئ أي التزام على المستشفى بتوفير
                    مواعيد حضور أو خدمات علاجية إضافية في مقرها.
                  </li>
                </ul>
              </div>

              {/* Section 10 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  10. سياسة الخصوصية وحماية المعلومات
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  بإستخدام المنصة، يقر المستخدم بأن جميع البيانات التي يتم جمعها
                  أو معالجتها من خلال المنصة تخضع لنظام حماية البيانات الشخصية
                  ولائحته التنفيذية المعمول بها في المملكة العربية السعودية.
                </p>

                {/* 10.1 */}
                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    1. جمع البيانات الشخصية
                  </h3>
                  <p className="mb-4 leading-relaxed text-gray-600">
                    يقر المستخدم بموافقته على جمع واستخدام الشركة لبياناته
                    الشخصية بغرض تقديم خدماتها وتحسينها، على أن تلتزم الشركة
                    باتخاذ كافة التدابير المناسبة لحماية هذه البيانات وسريتها
                    وعدم افشاؤها لأي طرف آخر إلا للجهات المصرح بها.
                  </p>

                  <p className="mb-2 font-semibold text-gray-700">
                    أ. البيانات التي قد تُجمع من المستخدم:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                    <li>الإسم الكامل للمستخدم ورقم الهوية الشخصية.</li>
                    <li>عنوان المستخدم وأرقام التواصل.</li>
                    <li>أرقام الحسابات البنكية والبطاقات الائتمانية.</li>
                    <li>صور المستخدم الثابتة أو المتحركة.</li>
                    <li>
                      الوثائق أو المواد الطبية المتعلقة بالحالة الصحية للمستخدم
                      وتشمل التقارير الطبية، نتائج الفحوص، والصور التشخيصية.
                    </li>
                    <li>بيانات تقنية (الجهاز – المتصفح – عنوان IP)</li>
                    <li>بيانات الجلسات.</li>
                    <li>
                      الملفات والمرفقات المقدمة من المستخدم ضمن متطلبات
                      الاستشارة الطبية أو وفق ما يطلبه الطبيب عبر المنصة.
                    </li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    ب. الغرض من جمع البيانات الشخصية للمستخدم:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                    <li>تقديم الخدمة وإدارة الملف الطبي للمستخدم.</li>
                    <li>التحقق من هوية المستخدم.</li>
                    <li>
                      استعراض الملف الصحي للمستخدم، والمتمثل بمجموعة المعلومات
                      التي توثق حالته الصحية.
                    </li>
                    <li>تطوير وتحسين الخدمات المقدمة عبر المنصة.</li>
                    <li>
                      الإمتثال للأنظمة والتعليمات المعمول بها في المملكة العربية
                      السعودية.
                    </li>
                    <li>
                      التواصل مع المستخدم عند الحاجة وذلك لتسهيل تقديم الخدمة،
                      تشغيل المنصة، والامتثال للأنظمة.
                    </li>
                    <li>
                      مراقبة وكشف مخالفات سياسة الاستخدام والخصوصية الخاصة
                      بالمنصة.
                    </li>
                    <li>
                      حفظ سجلات وبيانات المستخدم واستخدامها لتمكين التواصل معه
                      مستقبلاً عند الحاجة واستمرارية تقديم الخدمة.
                    </li>
                    <li>لأي غرض قانوني آخر قد يتم تحديده بموافقة المستخدم.</li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    ت. طرق جمع البيانات الشخصية للمستخدم:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                    <li>
                      <strong>الجمع المباشر:</strong> يتم عندما يزوّد المستخدم
                      البيانات بشكل صريح عبر المنصة، وذلك أثناء إنشاء الحساب،
                      حجز المواعيد، تعبئة الاستمارات، رفع المستندات الطبية أو
                      التقارير، وأي معلومات إضافية يطلبها الطبيب أثناء الاستشارة
                      الرقمية.
                    </li>
                    <li>
                      <strong>البيانات المجمعة تلقائياً عبر المنصة:</strong> مثل
                      بيانات الجلسات، عنوان IP، نوع الجهاز والمتصفح، وسجلات
                      الاستخدام لتحسين أداء المنصة.
                    </li>
                    <li>
                      <strong>الجمع من خلال قنوات التواصل:</strong> وهي
                      المعلومات المستخلصة من التواصل مع المستخدم: من خلال البريد
                      الإلكتروني، الرسائل النصية، المكالمات الهاتفية، أو
                      الإشعارات داخل المنصة، بهدف متابعة الطلبات، حل المشكلات،
                      تأكيد أو تعديل المواعيد، وضمان استمرارية تقديم الخدمة.
                    </li>
                    <li>
                      <strong>الجمع من مصادر خارجية:</strong> عند الضرورة، قد
                      يتم جمع بيانات المستخدم من مقدمي خدمات متعاقدين مع الشركة،
                      مثل معالجة المدفوعات أو دعم الخدمات التقنية، وفقًا
                      لاتفاقيات سرية وضمن حدود الأغراض المحددة.
                    </li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    ث. مدة الإحتفاظ بالبيانات الشخصية للمستخدم:
                  </p>
                  <p className="mb-4 leading-relaxed text-gray-600">
                    يقر المستخدم بموافقته على احتفاظ الشركة بالبيانات الشخصية
                    الخاصة بالمستخدم – بما فيها البيانات الصحية - لمدة زمنية
                    مناسبة ومحددة لأغراض المعالجة و/أو وفقا للمتطلبات القانونية
                    أو التنظيمية أو المحاسبية أو الرقابية، وقد تختلف هذه المدد
                    حسب تقدير الشركة.
                  </p>

                  <p className="mb-2 font-semibold text-gray-700">
                    ج. مشاركة البيانات الشخصية للمستخدم:
                  </p>
                  <p className="mb-2 leading-relaxed text-gray-600">
                    إن دخول المستخدم الى المنصة واستخدامه يعتبر إقراراً منه
                    بالموافقة على مشاركة الشركة لبياناته الشخصية في الحدود
                    اللازمة لتقديم الخدمة، وذلك مع الجهات التالية:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                    <li>
                      الطبيب المختص المسؤول عن متابعة الحالة وتقديم الإستشارة
                      الطبية.
                    </li>
                    <li>
                      المستشفى في حال قبول الحالة أو لإستكمال أي اجراءات طبية
                      لاحقة.
                    </li>
                    <li>الجهات الحكومية المختصة عند الطلب.</li>
                    <li>مزودي خدمات ملتزمين باتفاقيات سرية.</li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    ح. الأسس النظامية لمعالجة البيانات الشخصية للمستخدم:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                    <li>
                      <strong>الموافقة الصريحة من المستخدم:</strong> يتم معالجة
                      البيانات الشخصية بناءً على موافقة المستخدم، وتشمل على سبيل
                      المثال لا الحصر:
                      <ul className="mt-2 list-disc space-y-1 pr-6">
                        <li>
                          الموافقة على استخدام المنصة والالتزام بسياسة الخصوصية
                          عند إنشاء الحساب.
                        </li>
                        <li>
                          الموافقة على شروط الخدمة قبل حجز موعد أو تقديم استشارة
                          طبية.
                        </li>
                        <li>
                          السماح للتطبيق بالوصول إلى بيانات محددة مثل الموقع
                          الجغرافي، الكاميرا، أو الصور الطبية.
                        </li>
                        <li>
                          الموافقة على استلام إشعارات ترويجية أو رسائل تسويقية.
                        </li>
                        <li>
                          المشاركة في الاستبيانات أو تقديم البيانات لأغراض تطوير
                          الخدمة وتحسينها.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>أداء الالتزام التعاقدي:</strong> يتم معالجة
                      البيانات الشخصية للوفاء بإلتزامات الشركة التعاقدية، مثل
                      إدارة المواعيد، اصدار الفواتير، معالجة طلبات الاسترداد
                      والدعم الفني المرتبط بالخدمة.
                    </li>
                    <li>
                      <strong>مصالح مشروعة:</strong> يتم معالجة البيانات الشخصية
                      بناءً على المصالح المشروعة للشركة في تحسين خدمات المنصة
                      وتعزيز تجربة المستخدم.
                    </li>
                    <li>
                      <strong>الإمتثال للأنظمة:</strong> يتم معالجة البيانات
                      الشخصية للإمتثال لإلتزام قانوني أو تنظيمي او محاسبي أو
                      رقابي.
                    </li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    خ. إتلاف البيانات الشخصية للمستخدم:
                  </p>
                  <p className="mb-4 leading-relaxed text-gray-600">
                    يتم إتلاف البيانات الشخصية للمستخدم بشكل آمن عند انتهاء
                    الحاجة إلى الاحتفاظ بها وفقًا لسياسة الشركة، أو عند طلب
                    المستخدم حذف بياناته، بما يضمن منع أي استخدام أو استرجاع غير
                    مصرح به لهذه البيانات.
                  </p>
                </div>

                {/* 10.2 */}
                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    2. حماية البيانات الشخصية للمستخدم
                  </h3>
                  <p className="mb-2 leading-relaxed text-gray-600">
                    تلتزم الشركة باتخاذ كافة التدابير اللازمة لحماية البيانات
                    الشخصية للمستخدم، وتشمل هذه الإجراءات:
                  </p>
                  <ul className="list-disc space-y-2 pr-6 text-gray-600">
                    <li>تخزين البيانات داخل المملكة العربية السعودية.</li>
                    <li>تشفير البيانات أثناء النقل والمعالجة.</li>
                    <li>
                      الالتزام بضوابط الهيئة السعودية للبيانات والذكاء الإصطناعي
                      SDAIA.
                    </li>
                    <li>الالتزام بضوابط الهيئة الوطنية للأمن السيبراني NCA.</li>
                    <li>آليات رقابة وصول محددة.</li>
                  </ul>
                </div>

                {/* 10.3 */}
                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    3. حقوق المستخدم
                  </h3>
                  <p className="mb-2 leading-relaxed text-gray-600">
                    للمستخدم الحق في:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pr-6 text-gray-600">
                    <li>
                      طلب الوصول الى بياناته الشخصية المعروضة على المنصة وطلب
                      نسخة منها.
                    </li>
                    <li>طلب تعديل بيانات غير صحيحة أو استكمالها أو تحديثها.</li>
                    <li>طلب حذف البيانات حيثما يسمح النظام.</li>
                    <li>
                      طلب إيقاف او تعطيل الحساب، مالم يتوفر مسوغ نظامي يمنع ذلك.
                    </li>
                    <li>طلب توضيح حول كيفية استخدام البيانات.</li>
                  </ul>
                  <p className="leading-relaxed text-gray-600">
                    يتم تقديم هذه الطلبات عبر رفع الطلب من خلال البريد
                    الالكتروني، وقد تطلب الشركة معلومات إضافية بهدف تنفيذ الطلب
                    أو التحقق من هوية المستخدم.
                  </p>
                </div>

                {/* 10.4 */}
                <div>
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    4. جمع البيانات الشخصية للأطفال أو من في حكمهم
                  </h3>
                  <ul className="list-disc space-y-2 pr-6 text-gray-600">
                    <li>
                      الحد الأدنى للسن المسموح به لاستخدام المنصة هو ثماني عشر
                      (18) سنة ميلادية.
                    </li>
                    <li>
                      في حالة قدم المستخدم بيانات شخصية لأشخاص دون سن الثامن عشر
                      (18) ميلادي أو من في حكمهم كناقصي الأهلية أو فاقديها، فيجب
                      عليه الإقرار بأنه الولي الشرعي له وموافقته على استخدام أو
                      معالجة البيانات الشخصية، مع تقديم ما يثبت الولاية.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Section 11 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  11. الملكية الفكرية
                </h2>
                <p className="leading-relaxed text-gray-600">
                  جميع المواد المتوفرة في المنصة بما في ذلك البيانات والمعلومات
                  والتصاميم والرسوم (بما في ذلك الرسوم التصويرية للمعلومات)
                  والنصوص والشيفرات البرمجية، والصفحات يعد ملكًا حصريًا للشركة،
                  ومحمية بموجب أنظمة الملكية الفكرية المعمول بها. ويُحظر على
                  المستخدم نسخ أي جزء من هذا المحتوى أو تعديله أو إعادة نشره أو
                  استخدامه خارج إطار الخدمة بأي شكل من الأشكال، إلا بعد الحصول
                  على موافقة خطية وصريحة من الشركة.
                </p>
              </div>

              {/* Section 12 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  12. نطاق المسؤولية
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  تقتصر مسؤولية الشركة – في جميع الحالات – على قيمة الخدمة
                  المدفوعة فقط، ولا تتحمل الشركة أو المستشفى أو القابضة أي
                  مسؤولية عن:
                </p>
                <ul className="list-disc space-y-2 pr-6 text-gray-600">
                  <li>الأضرار الغير مباشرة.</li>
                  <li>فقدان أو تلف البيانات.</li>
                  <li>
                    اعتماد المستخدم على الاستشارة الرقمية دون مراجعة طبية
                    حضورية.
                  </li>
                  <li>
                    قرارات علاجية اتخذها المستخدم استناداً الى معلومات غير
                    مكتملة أو غير دقيقة.
                  </li>
                </ul>
              </div>

              {/* Section 13 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  13. القانون المطبق والمحكمة المختصة
                </h2>
                <p className="leading-relaxed text-gray-600">
                  تخضع هذه السياسة للأنظمة المطبقة في المملكة العربية السعودية،
                  وتُحل النزاعات أولًا بالطرق الودية، وفي حال عدم التوصل لحل يتم
                  الرجوع للجهات القضائية المختصة داخل المملكة.
                </p>
              </div>

              {/* Section 14 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  14. تحديث سياسة الاستخدام والخصوصية
                </h2>
                <p className="leading-relaxed text-gray-600">
                  تحتفظ الشركة بالحق في تعديل سياسة الاستخدام والخصوصية هذه،
                  وسيتم إخطار المستخدم لإبداء الموافقة، وتحتفظ الشركة بالحق في
                  تعليق أو ايقاف الحساب في حال عدم قبول الاصدار الجديد من سياسة
                  الاستخدام والخصوصية.
                </p>
              </div>

              {/* Section 15 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  15. الموافقة الإلكترونية
                </h2>
                <p className="leading-relaxed text-gray-600">
                  باستخدام المنصة، يقر المستخدم بأنه قد أطلع على سياسة الاستخدام
                  والخصوصية، وفهم محتواها، وقبوله بالكامل بما جاء فيها،
                  وبإستمراره في استخدام المنصة يمثل قبولًا قانونيًا ملزمًا.
                </p>
              </div>
            </div>
          </section>

          {/* Divider */}
          <hr className="my-12 border-gray-200" />

          {/* English Section */}
          <section dir="ltr" className="mb-16">
            <h1 className="mb-8 text-2xl font-bold text-gray-900">
              Terms of Use &amp; Privacy Policy
            </h1>
            <p className="mb-8 text-gray-500">AlTakhassusi Consult Platform</p>

            <div className="space-y-8">
              {/* Section 1 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  1. Introduction and Purpose
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  These Terms of Use and the Privacy Policy ("Terms") govern
                  your access to and use of the Estashir Al-Takhassusi digital
                  medical consultation platform ("Platform"). Your use of the
                  Platform constitutes full and binding acceptance of these
                  Terms, including the Medical Liability Disclaimer, Payment
                  Policy, and No-Show Policy.
                </p>
                <p className="leading-relaxed text-gray-600">
                  The Platform is operated by{' '}
                  <strong>Al-Takhassusi General Company Ltd.</strong>{' '}
                  ("Company"), a subsidiary of King Faisal Specialist Hospital
                  International Holding Company, which is wholly owned by King
                  Faisal Specialist Hospital &amp; Research Centre
                  (KFSH&amp;RC). This ownership structure does not impose any
                  medical or clinical liability on the Hospital or the Holding
                  Company for services provided through the Platform.
                </p>
              </div>

              {/* Section 2 - Definitions */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  2. Definitions
                </h2>
                <ul className="list-disc space-y-3 pl-6 text-gray-600">
                  <li>
                    <strong>Platform:</strong> Estashir Al-Takhassusi Digital
                    Medical Consultation Platform.
                  </li>
                  <li>
                    <strong>Company:</strong> Al-Takhassusi General Limited
                    Company, a subsidiary of King Faisal Specialist Hospital
                    International Holding Company, hereinafter referred to as
                    the "Company."
                  </li>
                  <li>
                    <strong>Holding Company:</strong> King Faisal Specialist
                    Hospital International Holding Company, fully owned by the
                    Hospital, hereinafter referred to as the "Holding Company."
                  </li>
                  <li>
                    <strong>Hospital:</strong> King Faisal Specialist Hospital
                    &amp; Research Center, hereinafter referred to as the
                    "Hospital" or "KFSHRC".
                  </li>
                  <li>
                    <strong>User:</strong> A natural person who creates an
                    account on the Platform or uses its services, whether for
                    themselves or on behalf of another person whom they are
                    legally authorized to represent in accordance with
                    applicable laws and regulations.
                  </li>
                  <li>
                    <strong>Physicians:</strong> A licensed healthcare
                    practitioner authorized by the competent authorities in the
                    Kingdom of Saudi Arabia, independent of the Company, the
                    Holding Company, or the Hospital, who provides digital
                    medical consultations through the Platform.
                  </li>
                  <li>
                    <strong>Service Provider:</strong> Any external entity,
                    whether an individual or a company, that provides services
                    for operating, supporting, or delivering digital
                    consultations or services related to the Platform, including
                    technical support, payment services, infrastructure
                    services, identity verification, cybersecurity, compliance
                    services, and other services necessary for the Platform's
                    operation. This includes third-party service providers
                    contracted by the Company to operate the Platform and
                    provide services to Users.
                  </li>
                  <li>
                    <strong>Medical Documents:</strong> All medical documents or
                    materials related to the User's health condition submitted
                    to the Platform for the purpose of obtaining a medical
                    consultation, including documents from accredited sources
                    such as medical reports, test results, and diagnostic
                    images, treated as health data under the Privacy Policy.
                  </li>
                  <li>
                    <strong>Medical Information:</strong> Any personal
                    information related to an individual's physical, mental, or
                    psychological health or their healthcare services.
                  </li>
                  <li>
                    <strong>Personal Information:</strong> Any information,
                    regardless of its source or form, that can directly or
                    indirectly identify an individual, such as name, national ID
                    number, addresses, contact numbers, license numbers,
                    personal records, property information, bank account and
                    credit card numbers, still or moving images, and other
                    personal data.
                  </li>
                  <li>
                    <strong>Processing:</strong> Any operation performed on
                    personal data by electronic means, including collection,
                    recording, storage, indexing, arrangement, coordination,
                    modification, updating, merging, retrieval, use, disclosure,
                    transfer, publication, sharing, linkage, blocking, erasure,
                    and destruction.
                  </li>
                  <li>
                    <strong>Collection:</strong> The Platform obtaining personal
                    data in accordance with the provisions of the Personal Data
                    Law and its executive regulations, whether directly from the
                    data subject, their legal representative, guardian, or from
                    another party.
                  </li>
                  <li>
                    <strong>Session Data:</strong> Technical and administrative
                    data related to the digital medical session, collected and
                    processed in the context of providing the consultation via
                    the Platform, including start and end times, session status,
                    device and connection information (device type, operating
                    system, browser, IP address, connection quality), technical
                    logs, metadata, and any session recordings.
                  </li>
                  <li>
                    <strong>Service:</strong> The set of digital medical
                    consultation services provided by the Platform to the User.
                  </li>
                  <li>
                    <strong>Digital Consultation:</strong> A digital medical
                    service provided by a licensed physician through the
                    Platform, including communication with the User, review of
                    their medical documents, and responding to inquiries to
                    provide general medical advice to support health assessment,
                    without constituting a final clinical diagnosis or
                    establishing a direct treatment relationship with the
                    Hospital.
                  </li>
                  <li>
                    <strong>Appointment:</strong> A confirmed and prepaid
                    booking for a consultation session with a specific physician
                    at an agreed date and time via the Platform.
                  </li>
                  <li>
                    <strong>Consultative Diagnosis:</strong> The analytical
                    Consultative Diagnosis issued by the licensed physician
                    based on the medical documents submitted through the
                    Platform, intended to support medical evaluation within the
                    digital service, and not considered a final clinical
                    diagnosis nor establishing a treatment relationship with the
                    Hospital.
                  </li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  3. Scope and Nature of Services
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  1. The Platform provides remote medical consultation services,
                  including:
                </p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>Video-based consultations</li>
                  <li>
                    Review of the medical documents submitted by the User.
                  </li>
                  <li>Providing a consultative diagnosis.</li>
                  <li>Responding to the User's medical-related inquiries.</li>
                </ul>
                <p className="mb-4 leading-relaxed text-gray-600">
                  2. Services are <strong>consultative in nature</strong> and do
                  not constitute diagnosis, treatment, or medical intervention.
                  They do not replace in-person medical evaluation or emergency
                  care.
                </p>
                <p className="leading-relaxed text-gray-600">
                  3. The accuracy of any medical opinion depends on the
                  completeness and accuracy of the medical documents supplied by
                  the user.
                </p>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  4. Medical Responsibility
                </h2>
                <ul className="mb-4 list-disc space-y-3 pl-6 text-gray-600">
                  <li>
                    The Service is provided by licensed and independently
                    practicing Physicians in accordance with the laws and
                    regulations of the Kingdom of Saudi Arabia. These Physicians
                    have no organizational, supervisory, or reporting
                    relationship with the Company, the Holding Company, or the
                    Hospital.
                  </li>
                  <li>
                    The Physician assumes full responsibility for:
                    <ul className="mt-2 list-disc space-y-1 pl-6">
                      <li>The consultative diagnosis.</li>
                      <li>The medical opinion.</li>
                      <li>Treatment recommendations.</li>
                      <li>
                        Any interpretation or explanation of medical
                        information.
                      </li>
                    </ul>
                  </li>
                  <li>
                    The Company, the Holding Company, and the Hospital shall not
                    be held liable for:
                    <ul className="mt-2 list-disc space-y-1 pl-6">
                      <li>Medical error.</li>
                      <li>Consequences or complications.</li>
                      <li>
                        Misunderstandings arising from reliance solely on the
                        consultation without an in-person medical review.
                      </li>
                      <li>
                        The User's reliance on the consultation in a manner
                        inconsistent with the Physician's instructions.
                      </li>
                    </ul>
                  </li>
                  <li>
                    The Platform, the Holding Company, and the Hospital do not
                    establish any employment, professional, or administrative
                    relationship with the Physician regarding Users, nor shall
                    they be considered a party to the treatment relationship
                    resulting from the digital consultation.
                  </li>
                  <li>
                    A consultation provided through the Platform does not create
                    any treatment relationship with the Hospital unless the case
                    is formally accepted in accordance with the Hospital's
                    internal admission policies, including coverage, evaluation,
                    or capacity considerations. Such consultation does not
                    entail any treatment obligations beyond the scope of the
                    digital consultation.
                  </li>
                </ul>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  5. User Representations and Warranties
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  The User acknowledges and agrees to the terms of the Terms of
                  Use and Privacy Policy, and further agrees to comply with the
                  following:
                </p>
                <p className="mb-2 font-semibold text-gray-700">
                  1. User Obligations:
                </p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>
                    Provide accurate and up-to-date information when creating an
                    account or using the Platform's services, and refrain from
                    submitting false, misleading, or fraudulent information, or
                    using forged documents.
                  </li>
                  <li>
                    Upload clear and unaltered medical documents and reports
                    that do not compromise the accuracy of the medical
                    consultation.
                  </li>
                  <li>
                    Use the account personally and not share login credentials
                    with any third party.
                  </li>
                  <li>
                    Adhere to proper usage etiquette and refrain from any
                    abusive communication with Physicians or support staff.
                  </li>
                  <li>
                    Refrain from any attempt at unauthorized access or taking
                    any action that may disrupt the Platform or affect its
                    security or system integrity.
                  </li>
                  <li>
                    Do not submit or upload files containing malicious software,
                    viruses, or corrupted data.
                  </li>
                  <li>
                    Bear all fines imposed by governmental authorities arising
                    from violation of the laws and regulations applicable in the
                    Kingdom of Saudi Arabia.
                  </li>
                </ul>
                <p className="leading-relaxed text-gray-600">
                  2. The Company reserves the right to take any legal action in
                  the event of the User's violation of these obligations,
                  including suspending or terminating the account, without
                  prejudice to the Company's right to claim compensation where
                  applicable.
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  6. Permitted and Prohibited Use
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  1. Use of the Platform is subject to the terms and conditions
                  governing the Service. All Users shall comply with lawful use
                  and shall not engage in any activity that violates the
                  applicable laws and regulations of the Kingdom of Saudi Arabia
                  or the Company's policies. Any use that may expose the
                  Platform, Users' data, or the Services to risk, or compromise
                  security or privacy, is strictly prohibited.
                </p>
                <p className="mb-2 font-semibold text-gray-700">
                  Permitted use includes (without limitation):
                </p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>Using the Service for legitimate medical purposes.</li>
                  <li>
                    Submitting inquiries related to the User's health condition.
                  </li>
                  <li>
                    Sharing medical reports and test results relating to the
                    User or to a person whom the User is legally authorized to
                    represent.
                  </li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">
                  Prohibited use includes (without limitation):
                </p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>
                    Providing false, misleading, or incomplete information
                  </li>
                  <li>Uploading harmful files or malware</li>
                  <li>
                    Attempting unauthorized access to other Users' accounts or
                    data.
                  </li>
                  <li>
                    Promoting external services or products or engaging in any
                    advertising activity through the Platform.
                  </li>
                  <li>
                    Using the Platform as a communication channel for
                    non-medical purposes or beyond its intended scope of use.
                  </li>
                  <li>
                    Committing any act in violation of the laws and regulations
                    of the Kingdom of Saudi Arabia or the Company's policies.
                  </li>
                </ul>
                <p className="leading-relaxed text-gray-600">
                  2. The Company reserves the right to take any legal or
                  regulatory action in the event of a User's violation of the
                  permitted use of the Platform, including suspending or
                  terminating the User's account, without prejudice to the
                  Company's right to claim compensation where applicable or to
                  report the violation to the competent authorities.
                </p>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  7. Payments, Cancellations, and No-Show Policy
                </h2>
                <p className="mb-2 font-semibold text-gray-700">1. Payments</p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>
                    Fees shall be paid through licensed payment service
                    providers.
                  </li>
                  <li>
                    Applicable fees shall be displayed to the User prior to
                    completion of the payment process.
                  </li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">
                  2. Cancellations
                </p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>
                    Users may cancel a booking at least 6 hours before the
                    scheduled time.
                  </li>
                  <li>
                    The Company is not obligated to reschedule the Appointment
                    after this period.
                  </li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">
                  3. No-Show Policy
                </p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>
                    If the user fails to attend a scheduled consultation without
                    cancelling within the required timeframe, the session is
                    considered fully consumed.
                  </li>
                  <li>
                    The User shall not be entitled to request a refund of the
                    fees or any compensation for failure to attend the
                    Appointment.
                  </li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">
                  4. Inability to Provide the Service
                </p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>
                    In the event that the Company is unable to provide the
                    Service, the User shall be entitled to either a refund of
                    the paid amount or rescheduling of the Appointment.
                  </li>
                  <li>
                    The Company shall contact the User through customer service
                    as soon as reasonably possible upon becoming aware of its
                    inability to provide the Service.
                  </li>
                </ul>
                <p className="mb-2 font-semibold text-gray-700">5. Refunds</p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>
                    Platform service fees are non-refundable except in cases
                    where the Company is unable to provide the Service,
                    including, without limitation, any of the following
                    circumstances:
                    <ul className="mt-2 list-disc space-y-1 pl-6">
                      <li>
                        Cancellation of the Appointment by the assigned
                        Physician.
                      </li>
                      <li>
                        Technical failures or system outages affecting the
                        Platform.
                      </li>
                      <li>
                        Internal Platform-related reasons preventing completion
                        of the session.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Refunds shall be processed through the payment platforms and
                    service providers contracted by the Company to process
                    payments, in accordance with the applicable refund policy.
                  </li>
                  <li>
                    Refund processing time varies depending on the payment
                    method, as follows:
                    <ul className="mt-2 list-disc space-y-1 pl-6">
                      <li>
                        Mada Card: within twenty-four (24) hours to three (3)
                        business days from the date of refund approval.
                      </li>
                      <li>
                        Credit Cards: within seventy-two (72) hours up to
                        fourteen (14) business days from the date of refund
                        approval.
                      </li>
                    </ul>
                  </li>
                  <li>
                    The Company shall not be liable for any loss incurred by the
                    User as a result of any act or omission by the external
                    payment service provider.
                  </li>
                </ul>
              </div>

              {/* Section 8 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  8. Technical Failures and Communication
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  1. The Company shall not be liable for any technical failures
                  arising from the User's side, including, without limitation:
                </p>
                <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                  <li>Internet connectivity issues experienced by the User</li>
                  <li>Weak or unstable network connections.</li>
                  <li>
                    Malfunctions of the device used to access the Platform.
                  </li>
                  <li>
                    Use of outdated or unsupported versions of operating systems
                    or applications.
                  </li>
                </ul>
                <p className="leading-relaxed text-gray-600">
                  2. Where the technical failure or malfunction is attributable
                  to the Company's systems, the Company shall contact the User
                  through customer service to either reschedule the Appointment
                  or process a refund of the applicable fees.
                </p>
              </div>

              {/* Section 9 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  9. Hospital Admission and Clinical Relationship
                </h2>
                <ul className="list-disc space-y-2 pl-6 text-gray-600">
                  <li>
                    Any referral issued by the Physician through the Platform
                    shall not constitute an official acceptance of the case by
                    the Hospital.
                  </li>
                  <li>
                    Acceptance of cases is subject to the Hospital's internal
                    policies relating to medical evaluation, capacity, and
                    eligibility.
                  </li>
                  <li>
                    The digital consultation does not create any rights or
                    treatment obligations within the Hospital unless the case is
                    formally accepted.
                  </li>
                  <li>
                    The digital consultation does not obligate the Hospital to
                    provide in-person appointments or additional treatment
                    services at its premises.
                  </li>
                </ul>
              </div>

              {/* Section 10 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  10. Privacy and Data Protection
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  By using the Platform, the User acknowledges that all data
                  collected or processed through the Platform is subject to the
                  Personal Data Protection Law and its executive regulations
                  applicable in the Kingdom of Saudi Arabia.
                </p>

                {/* 10.1 */}
                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    1. Collection of Personal Data
                  </h3>
                  <p className="mb-4 leading-relaxed text-gray-600">
                    The User acknowledges and consents to the Company's
                    collection and use of their personal data for the purpose of
                    providing and improving its services, provided that the
                    Company undertakes to take all appropriate measures to
                    protect such data, maintain its confidentiality, and not
                    disclose it to any party other than authorized entities.
                  </p>

                  <p className="mb-2 font-semibold text-gray-700">
                    a. Data that may be collected from the User:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                    <li>User's full name and national ID number.</li>
                    <li>User's address and contact numbers.</li>
                    <li>Bank account and credit card numbers.</li>
                    <li>Still or moving images of the User.</li>
                    <li>
                      Medical documents or materials related to the User's
                      health condition, including medical reports, test results,
                      and diagnostic images.
                    </li>
                    <li>Technical data (device – browser – IP address)</li>
                    <li>Session data.</li>
                    <li>
                      Files and attachments submitted by the User as part of the
                      medical consultation requirements or as requested by the
                      Physician through the Platform.
                    </li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    b. Purpose of collecting the User's personal data:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                    <li>
                      Providing the Service and managing the User's medical
                      file.
                    </li>
                    <li>Verifying the User's identity.</li>
                    <li>
                      Reviewing the User's health file, which consists of
                      information documenting their health condition.
                    </li>
                    <li>
                      Developing and improving the services provided through the
                      Platform.
                    </li>
                    <li>
                      Compliance with the laws and regulations applicable in the
                      Kingdom of Saudi Arabia.
                    </li>
                    <li>
                      Communicating with the User when necessary to facilitate
                      service delivery, operate the Platform, and comply with
                      regulations.
                    </li>
                    <li>
                      Monitoring and detecting violations of the Platform's
                      Terms of Use and Privacy Policy.
                    </li>
                    <li>
                      Maintaining User records and data to enable future
                      communication when needed and ensure continuity of
                      service.
                    </li>
                    <li>
                      Any other lawful purpose that may be identified with the
                      User's consent.
                    </li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    c. Methods of collecting the User's personal data:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                    <li>
                      <strong>Direct collection:</strong> This occurs when the
                      User explicitly provides data through the Platform, such
                      as during account creation, booking appointments, filling
                      out forms, uploading medical documents or reports, and any
                      additional information requested by the Physician during
                      the digital consultation.
                    </li>
                    <li>
                      <strong>
                        Data collected automatically through the Platform:
                      </strong>{' '}
                      Such as session data, IP address, device and browser type,
                      and usage logs to improve Platform performance.
                    </li>
                    <li>
                      <strong>
                        Collection through communication channels:
                      </strong>{' '}
                      Information obtained from communication with the User via
                      email, text messages, phone calls, or in-app
                      notifications, for the purpose of following up on
                      requests, resolving issues, confirming or modifying
                      appointments, and ensuring continuity of service.
                    </li>
                    <li>
                      <strong>Collection from external sources:</strong> When
                      necessary, User data may be collected from service
                      providers contracted with the Company, such as payment
                      processing or technical support services, in accordance
                      with confidentiality agreements and within the limits of
                      specified purposes.
                    </li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    d. Retention period for the User's personal data:
                  </p>
                  <p className="mb-4 leading-relaxed text-gray-600">
                    The User acknowledges and consents to the Company retaining
                    their personal data – including health data – for an
                    appropriate and specified period for processing purposes
                    and/or in accordance with legal, regulatory, accounting, or
                    supervisory requirements, and such periods may vary at the
                    Company's discretion.
                  </p>

                  <p className="mb-2 font-semibold text-gray-700">
                    e. Sharing of the User's personal data:
                  </p>
                  <p className="mb-2 leading-relaxed text-gray-600">
                    The User's access to and use of the Platform constitutes
                    acknowledgment of their consent to the Company sharing their
                    personal data to the extent necessary to provide the
                    Service, with the following entities:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                    <li>
                      The assigned Physician responsible for following up on the
                      case and providing the medical consultation.
                    </li>
                    <li>
                      The Hospital in case of acceptance of the case or to
                      complete any subsequent medical procedures.
                    </li>
                    <li>Competent governmental authorities upon request.</li>
                    <li>
                      Service providers bound by confidentiality agreements.
                    </li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    f. Legal bases for processing the User's personal data:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                    <li>
                      <strong>Explicit consent from the User:</strong> Personal
                      data is processed based on the User's consent, including,
                      without limitation:
                      <ul className="mt-2 list-disc space-y-1 pl-6">
                        <li>
                          Consent to use the Platform and comply with the
                          Privacy Policy upon account creation.
                        </li>
                        <li>
                          Consent to the Terms of Service before booking an
                          appointment or requesting a medical consultation.
                        </li>
                        <li>
                          Allowing the application to access specific data such
                          as location, camera, or medical images.
                        </li>
                        <li>
                          Consent to receive promotional notifications or
                          marketing messages.
                        </li>
                        <li>
                          Participation in surveys or providing data for service
                          development and improvement purposes.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Performance of contractual obligations:</strong>{' '}
                      Personal data is processed to fulfill the Company's
                      contractual obligations, such as managing appointments,
                      issuing invoices, processing refund requests, and
                      providing technical support related to the Service.
                    </li>
                    <li>
                      <strong>Legitimate interests:</strong> Personal data is
                      processed based on the Company's legitimate interests in
                      improving Platform services and enhancing user experience.
                    </li>
                    <li>
                      <strong>Regulatory compliance:</strong> Personal data is
                      processed to comply with legal, regulatory, accounting, or
                      supervisory obligations.
                    </li>
                  </ul>

                  <p className="mb-2 font-semibold text-gray-700">
                    g. Destruction of the User's personal data:
                  </p>
                  <p className="mb-4 leading-relaxed text-gray-600">
                    The User's personal data is securely destroyed when there is
                    no longer a need to retain it in accordance with Company
                    policy, or upon the User's request to delete their data, in
                    a manner that prevents any unauthorized use or retrieval of
                    such data.
                  </p>
                </div>

                {/* 10.2 */}
                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    2. Protection of the User's Personal Data
                  </h3>
                  <p className="mb-2 leading-relaxed text-gray-600">
                    The Company undertakes to take all necessary measures to
                    protect the User's personal data, including:
                  </p>
                  <ul className="list-disc space-y-2 pl-6 text-gray-600">
                    <li>Data storage within the Kingdom of Saudi Arabia.</li>
                    <li>
                      Encryption of data during transmission and processing.
                    </li>
                    <li>
                      Compliance with the Saudi Data and Artificial Intelligence
                      Authority (SDAIA) guidelines.
                    </li>
                    <li>
                      Compliance with the National Cybersecurity Authority (NCA)
                      guidelines.
                    </li>
                    <li>Specific access control mechanisms.</li>
                  </ul>
                </div>

                {/* 10.3 */}
                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    3. User Rights
                  </h3>
                  <p className="mb-2 leading-relaxed text-gray-600">
                    The User has the right to:
                  </p>
                  <ul className="mb-4 list-disc space-y-2 pl-6 text-gray-600">
                    <li>
                      Request access to their personal data displayed on the
                      Platform and request a copy thereof.
                    </li>
                    <li>
                      Request correction, completion, or update of inaccurate
                      data.
                    </li>
                    <li>Request deletion of data where permitted by law.</li>
                    <li>
                      Request suspension or deactivation of the account, unless
                      there is a legal basis preventing such action.
                    </li>
                    <li>
                      Request clarification on how their data is being used.
                    </li>
                  </ul>
                  <p className="leading-relaxed text-gray-600">
                    Such requests are submitted by raising a request through
                    email, and the Company may request additional information to
                    process the request or verify the User's identity.
                  </p>
                </div>

                {/* 10.4 */}
                <div>
                  <h3 className="mb-3 text-lg font-semibold text-gray-800">
                    4. Collection of Personal Data of Children or Those Under
                    Legal Guardianship
                  </h3>
                  <ul className="list-disc space-y-2 pl-6 text-gray-600">
                    <li>
                      The minimum age allowed to use the Platform is eighteen
                      (18) years.
                    </li>
                    <li>
                      If the User submits personal data for individuals under
                      the age of eighteen (18) or those under legal guardianship
                      (such as those with limited or no legal capacity), they
                      must confirm that they are the legal guardian and consent
                      to the use or processing of personal data, while providing
                      proof of guardianship.
                    </li>
                  </ul>
                </div>
              </div>

              {/* Section 11 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  11. Intellectual Property
                </h2>
                <p className="leading-relaxed text-gray-600">
                  All materials available on the Platform, including data,
                  information, designs, graphics (including infographics),
                  texts, software code, and pages are the exclusive property of
                  the Company and are protected under applicable intellectual
                  property laws. The User is prohibited from copying, modifying,
                  republishing, or using any part of this content outside the
                  scope of the Service in any form without obtaining prior
                  written and explicit consent from the Company.
                </p>
              </div>

              {/* Section 12 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  12. Limitation of Liability
                </h2>
                <p className="mb-4 leading-relaxed text-gray-600">
                  The Company's liability – in all cases – is limited to the
                  value of the paid Service only. The Company, the Hospital, or
                  the Holding Company shall not be liable for:
                </p>
                <ul className="list-disc space-y-2 pl-6 text-gray-600">
                  <li>Indirect damages.</li>
                  <li>Loss or corruption of data.</li>
                  <li>
                    The User's reliance on the digital consultation without an
                    in-person medical review.
                  </li>
                  <li>
                    Treatment decisions made by the User based on incomplete or
                    inaccurate information.
                  </li>
                </ul>
              </div>

              {/* Section 13 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  13. Governing Law and Jurisdiction
                </h2>
                <p className="leading-relaxed text-gray-600">
                  These Terms are governed by the laws of the Kingdom of Saudi
                  Arabia. Disputes shall first be addressed amicably, and if
                  unresolved, submitted to the competent courts within the
                  Kingdom.
                </p>
              </div>

              {/* Section 14 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  14. Policy Updates
                </h2>
                <p className="leading-relaxed text-gray-600">
                  The Company reserves the right to amend these Terms of Use and
                  Privacy Policy, and the User will be notified to provide their
                  consent. The Company reserves the right to suspend or
                  terminate the account in case of non-acceptance of the new
                  version of the Terms of Use and Privacy Policy.
                </p>
              </div>

              {/* Section 15 */}
              <div>
                <h2 className="mb-4 text-xl font-bold text-gray-900">
                  15. Electronic Consent
                </h2>
                <p className="leading-relaxed text-gray-600">
                  By using the Platform, the User acknowledges that they have
                  read the Terms of Use and Privacy Policy, understood its
                  contents, and fully accepted all its provisions. Continued use
                  of the Platform constitutes legally binding acceptance.
                </p>
              </div>
            </div>
          </section>
        </motion.div>
      </div>
    </div>
  );
}
